import React from "react";
import {
  Box, Divider, FormControl, FormControlLabel,
  FormLabel, Grid, InputAdornment, MenuItem,
  Radio, RadioGroup, TextField, Typography,
} from "@mui/material";

const EDUCATION_OPTIONS = [
  { value: "basica",                label: "Básica" },
  { value: "secundaria",            label: "Secundaria" },
  { value: "universitaria",         label: "Universitaria" },
  { value: "formacion_profesional", label: "Formación profesional" },
];

const MARITAL_OPTIONS = [
  { value: "soltero",   label: "Soltero/a" },
  { value: "casado",    label: "Casado/a" },
  { value: "divorciado",label: "Divorciado/a" },
];

const OCCUPATION_OPTIONS = [
  { value: "empleado",    label: "Empleado/a" },
  { value: "desempleado", label: "Desempleado/a" },
  { value: "jubilado",    label: "Jubilado/a" },
  { value: "otro",        label: "Otro" },
];

export default function PatientInfo({ form, onChange }) {
  return (
    <Box>
      <Typography variant="h6" fontWeight={700} color="primary" gutterBottom>
        Información del Paciente
      </Typography>
      <Divider sx={{ mb: 3 }} />

      <Grid container spacing={2.5}>
        {/* Código */}
        <Grid item xs={12} sm={6}>
          <TextField
            label="Código del paciente"
            name="patient_code"
            value={form.patient_code}
            onChange={onChange}
            fullWidth
          />
        </Grid>

        {/* Fecha de nacimiento */}
        <Grid item xs={12} sm={6}>
          <TextField
            label="Fecha de nacimiento"
            name="date_of_birth"
            type="date"
            value={form.date_of_birth}
            onChange={onChange}
            fullWidth
            InputLabelProps={{ shrink: true }}
          />
        </Grid>

        {/* Género */}
        <Grid item xs={12} sm={6}>
          <FormControl>
            <FormLabel>Género</FormLabel>
            <RadioGroup
              row
              name="gender"
              value={form.gender}
              onChange={onChange}
            >
              <FormControlLabel value="FEMALE" control={<Radio />} label="Femenino" />
              <FormControlLabel value="MALE"   control={<Radio />} label="Masculino" />
            </RadioGroup>
          </FormControl>
        </Grid>

        {/* Peso */}
        <Grid item xs={12} sm={6}>
          <TextField
            label="Peso"
            name="weight_kg"
            type="number"
            value={form.weight_kg}
            onChange={onChange}
            fullWidth
            InputProps={{ endAdornment: <InputAdornment position="end">kg</InputAdornment> }}
            inputProps={{ min: 0, step: 0.1 }}
          />
        </Grid>

        {/* Educación */}
        <Grid item xs={12} sm={6}>
          <TextField
            select
            label="Nivel educativo"
            name="education"
            value={form.education}
            onChange={onChange}
            fullWidth
          >
            {EDUCATION_OPTIONS.map((o) => (
              <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>
            ))}
          </TextField>
        </Grid>

        {/* Estado civil */}
        <Grid item xs={12} sm={6}>
          <TextField
            select
            label="Estado civil"
            name="marital_status"
            value={form.marital_status}
            onChange={onChange}
            fullWidth
          >
            {MARITAL_OPTIONS.map((o) => (
              <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>
            ))}
          </TextField>
        </Grid>

        {/* Mano dominante */}
        <Grid item xs={12} sm={6}>
          <FormControl>
            <FormLabel>Mano dominante</FormLabel>
            <RadioGroup
              row
              name="dominant_hand"
              value={form.dominant_hand}
              onChange={onChange}
            >
              <FormControlLabel value="derecha"   control={<Radio />} label="Derecha" />
              <FormControlLabel value="izquierda" control={<Radio />} label="Izquierda" />
            </RadioGroup>
          </FormControl>
        </Grid>

        {/* Mano parética */}
        <Grid item xs={12} sm={6}>
          <FormControl>
            <FormLabel>Mano parética</FormLabel>
            <RadioGroup
              row
              name="PARETIC_SIDE"
              value={form.PARETIC_SIDE}
              onChange={onChange}
            >
              <FormControlLabel value="LEFT"  control={<Radio />} label="Izquierda" />
              <FormControlLabel value="RIGHT" control={<Radio />} label="Derecha" />
            </RadioGroup>
          </FormControl>
        </Grid>

        {/* Ocupación */}
        <Grid item xs={12} sm={6}>
          <TextField
            select
            label="Ocupación"
            name="occupation"
            value={form.occupation}
            onChange={onChange}
            fullWidth
          >
            {OCCUPATION_OPTIONS.map((o) => (
              <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>
            ))}
          </TextField>
        </Grid>
      </Grid>
    </Box>
  );
}
